let deferredPrompt;

export function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .then(() => {
          console.log("ServiceWorker registration successful");
        })
        .catch((err) => {
          console.error("ServiceWorker registration failed:", err);
        });
    });

    // Handle install prompt
    const installButton = document.getElementById("install-app");

    window.addEventListener("beforeinstallprompt", (e) => {
      // Save the prompt
      deferredPrompt = e;
      // Show the button
      installButton?.removeAttribute("hidden");
      // Removed e.preventDefault() so browser can show its prompt too
    });

    // Handle button click
    installButton?.addEventListener("click", async () => {
      if (!deferredPrompt) return;
      // Show install prompt
      deferredPrompt.prompt();
      // Wait for response
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`Install prompt outcome: ${outcome}`);
      // Clear the prompt
      deferredPrompt = null;
      // Hide the button
      installButton.setAttribute("hidden", "");
    });

    // Hide button if app gets installed
    window.addEventListener("appinstalled", () => {
      installButton?.setAttribute("hidden", "");
      deferredPrompt = null;
    });
  }
}
